/* eslint-disable default-case */
import moment from "moment";
export function generateDefaultPodProduct(data, state) {
  const result = [
    ...processPremiumPlan(data.plans, state),
    ...processAddons(data.addons),
    ...processCollectionCharges(data.charges.collection_charge,state),
    ...processCollectionCongestionCharges(
      data.charges.collection_congestion_charge,state
    ),
    // ...processReturnCharges(data.charges.return_charge),
    // ...processReturnCongestionCharges(data.charges.return_congestion_charge),
  ];
console.log("jok", data, result);

  return result;
}

// Process Premium Plan
const processPremiumPlan = (plans, state) => {
  console.log("tak-90", import.meta.env);

  const premiumPlan = plans.find(
    (plan) => state?.service_type === "drop_store" ?plan.stripe_product_id === import.meta.env.REACT_APP_PRODUCT_Drop_Store  :plan.stripe_product_id === import.meta.env.REACT_APP_PRODUCT_Collect_Store 
  );
  if (!premiumPlan?.product_prices.length) return [];
  const [firstPrice] = premiumPlan.product_prices;
  return [
    {
      id: firstPrice.id,
      name: premiumPlan.name,
      type: premiumPlan.type,
      quantity: firstPrice.tier_start_unit || 1,
      price_id: firstPrice.stripe_product_id,
      cost: firstPrice.unit_amount,
      total: firstPrice.unit_amount * (firstPrice.tier_start_unit || 1),
      product_prices: premiumPlan.product_prices,
    },
  ];
};

// Process Addons
const processAddons = (addons) => {
  return addons.flatMap((addon) =>
    addon.product_prices.map((price) => ({
      id: price.id,
      name: addon.name,
      type: addon.type,
      quantity: 1,
      cover: 4000,
      price_id: price.stripe_product_id,
      cost: price.unit_amount,
      total: price.unit_amount * 4,
    }))
  );
};

// Process Collection Charges
const processCollectionCharges = (collectionCharges,state) => {

  if (state?.service_type === "drop_store") return [];

  const collection = collectionCharges.find(
    (charge) =>
      charge.stripe_product_id ===
      import.meta.env.REACT_APP_PRODUCT_COLLECTION_SERVICE
  );
  if (!collection?.product_prices.length) return [];
  const [firstPrice] = collection.product_prices;
  return [
    {
      id: firstPrice.id,
      name: collection.name,
      type: collection.type,
      quantity: firstPrice.tier_start_unit || 1,
      price_id: firstPrice.stripe_product_id,
      cost: firstPrice.unit_amount,
      total: firstPrice.unit_amount * (firstPrice.tier_start_unit || 1),
      product_prices: collection.product_prices,
    },
  ];
};

// Process Collection Congestion Charges
const processCollectionCongestionCharges = (collectionCongestionCharges,state) => {

  if (state?.service_type === "drop_store") return [];

  return collectionCongestionCharges.flatMap((charge) =>
    charge.product_prices.map((price) => ({
      id: price.id,
      name: charge.name,
      type: charge.type,
      quantity: 1,
      price_id: price.stripe_product_id,
      cost: price.unit_amount,
      total: price.unit_amount,
    }))
  );
};

// Process Return Charges
const processReturnCharges = (returnCharges) => {
  return returnCharges.flatMap((charge) =>
    charge.product_prices.map((price) => ({
      id: price.id,
      name: charge.name,
      type: charge.type,
      quantity: 1,
      price_id: price.stripe_product_id,
      cost: price.unit_amount,
      total: price.unit_amount,
    }))
  );
};

// Process Return Congestion Charges
const processReturnCongestionCharges = (returnCongestionCharges) => {
  return returnCongestionCharges.flatMap((charge) =>
    charge.product_prices.map((price) => ({
      id: price.id,
      name: charge.name,
      type: charge.type,
      quantity: 1,
      price_id: price.stripe_product_id,
      cost: price.unit_amount,
      total: price.unit_amount,
    }))
  );
};

// Example usage

export function transformDataToAddProduct(charge) {
  // Initialize a default object
  console.log("charge-90", charge);

  const transformedObject = {
    id: null,
    name: charge.name,
    type: charge.type,
    quantity: 1,
    price_id: charge.stripe_product_id,
    cost: charge.price || null,
    total: charge.price || null,
    product_prices: null,
  };

  // Check if charge.product_prices exists and has at least one item
  if (charge.product_prices && charge.product_prices.length > 0) {
    // Process only the first item (index 0)
    const price = charge.product_prices[0];
    transformedObject.id = price.id;
    transformedObject.price_id = price.stripe_product_id;
    transformedObject.cost = price.unit_amount;
    transformedObject.total = price.unit_amount;
    transformedObject.product_prices = charge.product_prices;
  }

  return transformedObject;
}

export const isItemExists = (array, item) => {
  // Adjust the identifier based on your actual use case (e.g., 'id')

  return array.some((existingItem) => existingItem.price_id === item.price_id);
};

export function multiplyCostByNumber(data, number, state) {
  return data.map((item) => {
    if (item.type === "plan") {
      return {
        ...item,
        // cost: (parseFloat(item.cost) * number).toFixed(2),
        total:
          item?.product_prices && item?.product_prices?.length == 1
            ? (parseFloat(item.cost) * number * item?.quantity).toFixed(2)
            : (parseFloat(item.cost) * number).toFixed(2),
      };
    }
    if (item.type === "addon") {
      if (
        item?.price_id === import.meta.env.REACT_APP_PRODUCT_POD_PROTECT ||
        item?.price_id === import.meta.env.REACT_APP_PRODUCT_STORE_PROTECT ||
        item?.price_id === "Storeprotect"
      ) {
        return {
          ...item,
          // cost: (parseFloat(item.cost) * number).toFixed(2),
          total: ((parseFloat(item.cost) * number * item.cover) / 1000).toFixed(
            2
          ),
        };
      } else {
        return {
          ...item,
          // cost: (parseFloat(item.cost) * number).toFixed(2),
          total: (parseFloat(item.cost) * number).toFixed(2),
        };
      }
    }

    return item;
  });
}

export function calculateDefaultDiscount(data, discount, value,unit) {
  let discountAmount = 0;

  console.log("unit-unit", unit);
  // Find coupon discount
  const planDiscount = discount.find((d) => d.object === "coupon");
  if (!planDiscount) return discountAmount;

  data.forEach((item) => {
    if (item.type === "plan") {
      const totalCycles = unit || 1; // jitne cycles user ne select kiye
      let cyclesToDiscount = totalCycles;

      if (planDiscount.duration === "once") {
        cyclesToDiscount = 1;
      } else if (planDiscount.duration === "repeating") {
        cyclesToDiscount = Math.min(planDiscount.duration_in_months, totalCycles);
      } // agar forever h to pura chalega

      const perCyclePrice = parseFloat(item.total) / totalCycles;

      const itemDiscount =
        (perCyclePrice * planDiscount.percent_off * cyclesToDiscount) / 100;

      discountAmount += itemDiscount;
    }
  });
  return discountAmount;
}


export function isWeekend(dateString) {
  const date = new Date(dateString);
  const day = date.getDay(); // 0 (Sunday) to 6 (Saturday)
  const publicHolidays = [
    // 2024 Holidays
    "2024-01-01", // New Year's Day
    "2024-03-29", // Good Friday
    "2024-04-01", // Easter Monday
    "2024-05-06", // Early May Bank Holiday
    "2024-05-27", // Spring Bank Holiday
    "2024-08-26", // Summer Bank Holiday
    "2024-12-25", // Christmas Day
    "2024-12-26", // Boxing Day,
    // 2025 Holidays
    "2025-01-01", // New Year's Day
    "2025-04-18", // Good Friday
    "2025-04-21", // Easter Monday
    "2025-05-05", // Early May Bank Holiday
    "2025-05-26", // Spring Bank Holiday
    "2025-08-25", // Summer Bank Holiday
    "2025-12-25", // Christmas Day
    "2025-12-26", // Boxing Day

    // 2026 Holidays
    "2026-01-01", // New Year's Day
    "2026-04-03", // Good Friday
    "2026-04-06", // Easter Monday
    "2026-05-04", // Early May Bank Holiday
    "2026-05-25", // Spring Bank Holiday
    "2026-08-31", // Summer Bank Holiday
    "2026-12-25", // Christmas Day
    "2026-12-28", // Boxing Day (Substitute)

    // 2027 Holidays
    "2027-01-01", // New Year's Day
    "2027-03-26", // Good Friday
    "2027-03-29", // Easter Monday
    "2027-05-03", // Early May Bank Holiday
    "2027-05-31", // Spring Bank Holiday
    "2027-08-30", // Summer Bank Holiday
    "2027-12-25", // Christmas Day
    "2027-12-27", // Boxing Day (Substitute)

    // 2028 Holidays
    "2028-01-01", // New Year's Day
    "2028-04-14", // Good Friday
    "2028-04-17", // Easter Monday
    "2028-05-01", // Early May Bank Holiday
    "2028-05-29", // Spring Bank Holiday
    "2028-08-28", // Summer Bank Holiday
    "2028-12-25", // Christmas Day
    "2028-12-26", // Boxing Day

    // 2029 Holidays
    "2029-01-01", // New Year's Day
    "2029-03-30", // Good Friday
    "2029-04-02", // Easter Monday
    "2029-05-07", // Early May Bank Holiday
    "2029-05-28", // Spring Bank Holiday
    "2029-08-27", // Summer Bank Holiday
    "2029-12-25", // Christmas Day
    "2029-12-26", // Boxing Day

    // 2030 Holidays
    "2030-01-01", // New Year's Day
    "2030-04-19", // Good Friday
    "2030-04-22", // Easter Monday
    "2030-05-06", // Early May Bank Holiday
    "2030-05-27", // Spring Bank Holiday
    "2030-08-26", // Summer Bank Holiday
    "2030-12-25", // Christmas Day
    "2030-12-26", // Boxing Day
  ];

  // Check if the date is a public holiday
  console.log("datedate", date, dateString);

  const formattedDate = date.toISOString().split("T")[0]; // Format date to 'YYYY-MM-DD'
  if (publicHolidays.includes(formattedDate)) {
    return "Public";
  }
  if (day === 0 || day === 6) {
    return "Weekend";
  } else {
    return "Weekday";
  }
}

/**
 * Price of a tiered per-pod charge (collection, weekend or bank holiday
 * collection) for a given number of pods.
 *
 * Tiers 1 to 6 hold the price for exactly that many pods. Above six pods the
 * price is tier 6 plus tier 7 for each pod over six. Used for both the line's
 * cost and its total, so the two cannot disagree.
 *
 * A tier priced at 0 is kept (`??`, not `||`). With no tier for that many
 * pods it falls back to tier 1, as before, and with no tiers at all it is 0
 * rather than an exception that stops the order screen.
 *
 * @param {Array<{unit_amount: number|string}>} productPrices Tiers in tier order.
 * @param {number} planQty Number of pods on the order.
 * @returns {number|string} The charge for that many pods.
 */
export const tieredChargeFor = (productPrices, planQty) =>
  productPrices?.length > 6 && planQty > 6
    ? Number(productPrices[5].unit_amount) +
      Number(productPrices[6].unit_amount) * Number(planQty - 6)
    : productPrices?.[planQty - 1]?.unit_amount ??
      productPrices?.[0]?.unit_amount ??
      0;

/**
 * Swap an order's collection charge line for the one that matches the
 * collection day: the weekend charge on a weekend, the bank holiday charge on
 * a bank holiday, and the standard collection service on a weekday. A line is
 * only added when not already present, and is priced for the order's number
 * of pods with tieredChargeFor, so its cost and total always agree.
 *
 * @param {{collection_charge: Array<Object>}} charges The collection charge products, each with its tiered product_prices.
 * @param {"Weekend"|"Weekday"|"Public"} dayType The collection day's type ("Public" is a bank holiday).
 * @param {Array<Object>} products The order's current product lines; the plan line's quantity is the pod count.
 * @param {string} order_type The order's type; a "drop_store" order gets no weekday collection service line.
 * @returns {Array<Object>} The product lines with the collection line for that day.
 */
export function updateChargesForDayType(charges, dayType, products, order_type ) {

  const collectionServiceCharge = charges.collection_charge.find(
    (charge) =>
      charge.stripe_product_id ===
      import.meta.env.REACT_APP_PRODUCT_COLLECTION_SERVICE
  );
  const weekendCharge = charges.collection_charge.find(
    (charge) =>
      charge.stripe_product_id === import.meta.env.REACT_APP_PRODUCT_WEEKEND_CHARGE
  );
  const pubHoliday = charges.collection_charge.find(
    (charge) =>
      charge.stripe_product_id === import.meta.env.REACT_APP_PRODUCT_COL_PUB_HOLIDAY
  );

  const planQty = products.find((e) => e.type === "plan")?.quantity;
  if (dayType === "Weekend") {
    // Remove "Collection Service" from products
    products = products.filter(
      (product) =>
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_COLLECTION_SERVICE &&
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_COL_PUB_HOLIDAY
    );

    // Add "Weekend Charge" if not already present
    if (
      !products.some(
        (product) =>
          product.price_id === import.meta.env.REACT_APP_PRODUCT_WEEKEND_CHARGE
      )
    ) {
      if (weekendCharge) {
        products.push({
          id: weekendCharge.id,
          name: weekendCharge.name,
          type: weekendCharge.type,
          quantity: planQty,
          product_prices: weekendCharge.product_prices,
          price_id: weekendCharge.stripe_product_id,
          cost: tieredChargeFor(weekendCharge.product_prices, planQty),
          total: tieredChargeFor(weekendCharge.product_prices, planQty),
        });
      }
    }
  } else if (dayType === "Weekday") {
    // Remove "Weekend Charge" from products
    products = products.filter(
      (product) =>
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_WEEKEND_CHARGE &&
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_COL_PUB_HOLIDAY
    );

    // Add "Collection Service" if not already present
    if (
      !products.some(
        (product) =>
          product.price_id === import.meta.env.REACT_APP_PRODUCT_COLLECTION_SERVICE
      ) && order_type != "drop_store"
    ) {
      if (collectionServiceCharge) {
        products.push({
          id: collectionServiceCharge.id,
          name: collectionServiceCharge.name,
          type: collectionServiceCharge.type,
          quantity: planQty,
          product_prices: collectionServiceCharge.product_prices,
          price_id: collectionServiceCharge.stripe_product_id,
          cost: tieredChargeFor(collectionServiceCharge.product_prices, planQty),
          total: tieredChargeFor(collectionServiceCharge.product_prices, planQty),
        });
      }
    }
  } else if (dayType === "Public") {
    // Remove "Weekend Charge" from products
    products = products.filter(
      (product) =>
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_WEEKEND_CHARGE &&
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_COLLECTION_SERVICE
    );
    console.log("products", products);

    // Add "Collection Service" if not already present
    if (
      !products.some(
        (product) =>
          product.price_id === import.meta.env.REACT_APP_PRODUCT_COL_PUB_HOLIDAY
      )
    ) {
      if (pubHoliday) {
        products.push({
          id: pubHoliday.id,
          name: pubHoliday.name,
          type: pubHoliday.type,
          quantity: planQty,
          product_prices: pubHoliday.product_prices,
          price_id: pubHoliday.stripe_product_id,
          cost: tieredChargeFor(pubHoliday.product_prices, planQty),
          total: tieredChargeFor(pubHoliday.product_prices, planQty),
        });
      }
    }
  }
  return products;
}

export function updateReturnChargesForDayType(charges, dayType, products) {
  const collectionServiceCharge = charges.return_charge.find(
    (charge) =>
      charge.stripe_product_id === import.meta.env.REACT_APP_PRODUCT_RET_SER
  );
  const weekendCharge = charges.return_charge.find(
    (charge) =>
      charge.stripe_product_id ===
      import.meta.env.REACT_APP_PRODUCT_RET_WEEKEND_CHARGE
  );
  const pubCharge = charges.return_charge.find(
    (charge) =>
      charge.stripe_product_id === import.meta.env.REACT_APP_PRODUCT_RET_PUB_HOLIDAY
  );
  if (dayType === "Weekend") {
    // Remove import.meta.env.REACT_APP_PRODUCT_RET_SER from products
    products = products.filter(
      (product) =>
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_RET_SER &&
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_RET_PUB_HOLIDAY
    );

    // Add import.meta.env.REACT_APP_PRODUCT_RET_WEEKEND_CHARGE if not already present
    if (
      !products.some(
        (product) =>
          product.price_id === import.meta.env.REACT_APP_PRODUCT_RET_WEEKEND_CHARGE
      )
    ) {
      if (weekendCharge) {
        products.push({
          id: weekendCharge.id,
          name: weekendCharge.name,
          type: weekendCharge.type,
          quantity: 1,
          product_prices: weekendCharge.product_prices,

          price_id: weekendCharge.stripe_product_id,
          cost: weekendCharge.product_prices[0].unit_amount,
          total: weekendCharge.product_prices[0].unit_amount,
        });
      }
    }
  } else if (dayType === "Weekday") {
    // Remove import.meta.env.REACT_APP_PRODUCT_RET_WEEKEND_CHARGE from products
    products = products.filter(
      (product) =>
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_RET_WEEKEND_CHARGE &&
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_RET_PUB_HOLIDAY
    );

    // Add import.meta.env.REACT_APP_PRODUCT_RET_SER if not already present
    if (
      !products.some(
        (product) => product.price_id === import.meta.env.REACT_APP_PRODUCT_RET_SER
      )
    ) {
      if (collectionServiceCharge) {
        products.push({
          id: collectionServiceCharge.id,
          name: collectionServiceCharge.name,
          type: collectionServiceCharge.type,
          quantity: 1,
          product_prices: collectionServiceCharge.product_prices,
          price_id: collectionServiceCharge.stripe_product_id,
          cost: collectionServiceCharge.product_prices[0].unit_amount,
          total: collectionServiceCharge.product_prices[0].unit_amount,
        });
      }
    }
  } else if (dayType === "Public") {
    // Remove import.meta.env.REACT_APP_PRODUCT_RET_WEEKEND_CHARGE from products
    products = products.filter(
      (product) =>
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_RET_WEEKEND_CHARGE &&
        product.price_id !== import.meta.env.REACT_APP_PRODUCT_RET_SER
    );

    // Add import.meta.env.REACT_APP_PRODUCT_RET_SER if not already present
    if (
      !products.some(
        (product) =>
          product.price_id === import.meta.env.REACT_APP_PRODUCT_RET_PUB_HOLIDAY
      )
    ) {
      if (pubCharge) {
        products.push({
          id: pubCharge.id,
          name: pubCharge.name,
          type: pubCharge.type,
          quantity: 1,
          product_prices: pubCharge.product_prices,
          price_id: pubCharge.stripe_product_id,
          cost: pubCharge.product_prices[0].unit_amount,
          total: pubCharge.product_prices[0].unit_amount,
        });
      }
    }
  }

  return products;
}

export const newOrderPaylod = (
  paymentId,
  state,
  orderSummaryListStripe,
  cardDetail,
  paymentIntentCus,
  formik
) => {
  function getProductNameByPriceId(data) {
    for (let item of data) {
      switch (item.price_id) {
        case import.meta.env.REACT_APP_PRODUCT_PREMIUM:
          return "Premium";
        case import.meta.env.REACT_APP_PRODUCT_ECONOMY:
          return "Economy";
        case import.meta.env.REACT_APP_PRODUCT_FIRST_CLASS:
          return "First Class";
        default:
          return item.price_id; // 👈 agar match na ho to yahin se return
      }
    }
    return "Default Product"; // 👈 agar data empty ho
}


  // Usage
  const productNames = getProductNameByPriceId(state.product_array);
  // const productNames = getProductNameByPriceId(state.product_array);
  function formatCouponData(coupons) {
    return coupons.map((coupon) => {
      return { coupon: coupon.id };
    });
  }
  function formateManualData(coupons) {
    return coupons.map((coupon) => {
      return { coupon: coupon.id };
    });
  }
  function filterPackagingMaterials(data, product) {
    return data
      .filter((item) => item.type === "packaging_material")
      .map((item) => {
        return product.find((prod) => prod.price_id === item.stripe_product_id);
      })
      .filter(Boolean); // Remove undefined values in case there are no matches
  }
  const qty =
    state?.product_array.find((e) => e.type === "plan")?.quantity || 0;
  const filteredAvailData = state?.avail ? state?.avail.slice(0, +qty) : [];
  
  const data = {
    id:
      cardDetail && cardDetail.length && cardDetail[0].id
        ? cardDetail[0].id
        : "",
    amount: state?.variantProductTotal?.total?.toFixed(2) || "",
    address:
      cardDetail && cardDetail.length && cardDetail[0].address
        ? cardDetail[0].address
        : "",
    adhoc_charge_price: "",
    adhoc_charge_quantity: "",
    agent_id:
      cardDetail &&
      cardDetail.length &&
      cardDetail[0].contact &&
      cardDetail[0].contact?.agent?.id
        ? cardDetail[0].contact?.agent?.id
        : "",
    apply_manual_discounts: "",
    bp_id: "POD",
    city:
      cardDetail && cardDetail.length && cardDetail[0].city
        ? cardDetail[0].city
        : "",
    collection_address_city:
      state.collectionRetrun?.collection_address_city || "",
    collection_address_line:
      state.collectionRetrun?.collection_address_line || "",
    collection_date: state.collectionRetrun?.collection_date || "",
    collection_postcode: state.collectionRetrun?.collection_postcode || "",
    collection_van_id: state.collectionRetrun?.collection_van_id || "",
    contact_id:
      cardDetail &&
      cardDetail.length &&
      cardDetail[0].contact &&
      cardDetail[0].contact?.id
        ? cardDetail[0].contact?.id
        : "",
    country: "GB",
    currency_code: "GBP",
    depot_id: state.collectionRetrun?.depot_id || "",
    // driver_note: "",
    email:
      cardDetail && cardDetail.length && cardDetail[0].email
        ? cardDetail[0].email
        : "",
    end_time_slot: state.collectionRetrun?.end_time_slot || "",
    first_name:
      cardDetail && cardDetail.length && cardDetail[0].first_name
        ? cardDetail[0].first_name
        : "",
    last_name:
      cardDetail && cardDetail.length && cardDetail[0].last_name
        ? cardDetail[0].last_name
        : "",
    franchise_id:
      cardDetail &&
      cardDetail.length &&
      cardDetail[0].contact &&
      cardDetail[0].contact?.franchise_id
        ? cardDetail[0].contact?.franchise_id
        : "",
    insurance_cover:
      state?.product_array.find(
        (e) =>
          e.price_id === import.meta.env.REACT_APP_PRODUCT_POD_PROTECT ||
          e.price_id === import.meta.env.REACT_APP_PRODUCT_STORE_PROTECT ||
          e.price_id === "Storeprotect"
      )?.cover || "",
    is_address_manual: "",
    is_collection_address: "",
    is_manual: "",
    is_manual_discount: "",
    is_return_address: "",
    is_return_address_manual: "",
    is_student: state.is_student || 0,
    is_student_return: state.is_student_return || 0,
    packaging_materials: "",
    payment_type: formik.values.paymentType,
    period: state?.billingParam?.unit || "",
    period_unit: state?.billingParam?.period || "",
    phone:
      cardDetail && cardDetail.length && cardDetail[0].phone
        ? cardDetail[0].phone
        : "",
    pod_plan_type: productNames || "",
    products: [],
    is_return:
      state.collectionRetrun?.return_date &&
      state.collectionRetrun?.return_start_time_slot
        ? 1
        : "0",
    return_start_time_slot:
      state.collectionRetrun?.return_start_time_slot || "",
    is_same_time_return: state.collectionRetrun?.return_start_time_slot ? 1 : 0,
    return_end_time_slot: state.collectionRetrun?.return_end_time_slot || "",
    return_address_line: state.collectionRetrun?.return_address_line || "",
    return_address_city: state.collectionRetrun?.return_address_city || "",
    return_van_id: state.collectionRetrun?.return_van_id || "",
    return_date: state.collectionRetrun?.return_date || "",
    return_postcode: state.collectionRetrun?.return_postcode || "",
    ship_packaging_materials: state?.is_packaging_check ? 1 : 0,
    is_billing_address: formik.values.billing === "same" ? 0 : 1,
    billing_address_one: formik.values.street1,
    billing_address_two: formik.values.street2,
    billing_city: formik.values.city,
    billing_postcode: formik.values.postCode,
    start_time_slot: state.collectionRetrun?.start_time_slot || "",
    state: "",
    storage_note: "",
    van_id: state.collectionRetrun?.van_id || "",
    default_payment_method: paymentId?.payment_method || "",
    planPodsQty:
      state?.product_array?.find((e) => e.type === "plan")?.quantity || 0,

    customer_id: paymentIntentCus?.data_two?.id || "",
    coupon_id: [
      ...(state?.default_coupon?.length > 0
        ? formatCouponData(state?.default_coupon)
        : []),
      ...formateManualData(state?.promoCoupon),
    ],
    is_container: state?.containerTypeSelect === "container" ? 1 : 0,
    container_collection_date:
      state.collectionRetrun?.container_collection_date || "",
    container_return_date: state.collectionRetrun?.container_return_date || "",
    access_type:
      state?.product_array.find(
        (e) =>
          e.price_id == import.meta.env.REACT_APP_PRODUCT_STANDARD_ACCESS ||
          e.price_id == import.meta.env.REACT_APP_PRODUCT_EXTENDED_ACCESS ||
          e.price_id == import.meta.env.REACT_APP_PRODUCT_24HR_ACCESS
      )?.price_id || "",
    container_size: state?.containerListSelect || "",
    franchise_container_id: filteredAvailData.map((e) => e.id) || "",
    site_id: state?.siteSelect?.id || "",
    deal_id: state?.deal_id || "",
    driver_note: state?.driverNote || "",
    total_discount:
      state?.variantProductTotal?.couponDiscount ||
      state?.variantProductTotal?.defaultDiscount
        ? Number(
            Number(state?.variantProductTotal?.couponDiscount) +
              Number(state?.variantProductTotal?.defaultDiscount || 0)
          ).toFixed(2)
        : "0.00",
    packagingMaterial: filterPackagingMaterials(
      orderSummaryListStripe?.allProducts,
      state?.product_array
    ),
  };

  const transformData = (data) => {
    return data.map((item) => {
      return {
        stripe_product_id: item.price_id,
        quantity: item.quantity,
        name: item.name,
        total: item.total,
        type: item.type,
        period: state?.billingParam?.unit || "",
        period_unit: state?.billingParam?.period || "",
        cover:
          item.price_id === import.meta.env.REACT_APP_PRODUCT_POD_PROTECT ||
          item.price_id === import.meta.env.REACT_APP_PRODUCT_STORE_PROTECT
            ? item.cover
            : "",
      };
    });
  };

  const transformedData = transformData(state?.product_array);
  
  data.products = transformedData;

  data.is_reservation = new Date(state.collectionRetrun?.collection_date).setHours(0,0,0,0) === new Date().setHours(0,0,0,0) ? 0 : 1;

  // Explicitly mark agent-created orders so the backend does not have to fall
  // back to its default (which is labelled "direct_order_fallback").
  data.workflow = "direct_order";

  return data;
};

//container
export function generateDefaultContainerProduct(data) {

  const result = [
    ...processContainerPlan(data.plans),
    ...processContainerAddons(data.addons),
    ...processContainerCharges(data.charges),
  ];

  return result;
}

const processContainerPlan = (plans) => {
  const premiumPlan = plans.find((plan) => plan.type === "plan");
  if (!premiumPlan?.product_prices.length) return [];
  const [firstPrice] = premiumPlan.product_prices;
  return [
    {
      id: firstPrice.id,
      name: premiumPlan.name,
      type: premiumPlan.type,
      quantity: firstPrice.tier_start_unit || 1,
      price_id: firstPrice.stripe_product_id,
      cost: firstPrice.unit_amount,
      total: firstPrice.unit_amount * (firstPrice.tier_start_unit || 1),
      product_prices: premiumPlan.product_prices,
    },
  ];
};
const processContainerAddons = (addons) => {
  const coverValue = 10000;
  return addons.flatMap((addon) =>
    addon.product_prices.map((price) => ({
      id: price.id,
      name: addon.name,
      type: addon.type,
      quantity: 1,
      cover: 10000,
      price_id: price.stripe_product_id,
      cost: price.unit_amount,
      total:
        price.stripe_product_id == import.meta.env.REACT_APP_PRODUCT_STORE_PROTECT
          ? price.unit_amount * (coverValue / 1000)
          : price.unit_amount,
    }))
  );
};
const processContainerCharges = (charges) => {
  // Flatten all charge categories into a single array
  const allCharges = Object.values(charges).flat();

  // Filter out the charges with specific product IDs
  const filteredCharges = allCharges.filter(
    (charge) =>
      charge.stripe_product_id !== import.meta.env.REACT_APP_PRODUCT_24HR_ACCESS &&
      charge.stripe_product_id !== import.meta.env.REACT_APP_PRODUCT_COL_SER_20FT &&
      charge.stripe_product_id !==
        import.meta.env.REACT_APP_PRODUCT_EXTENDED_ACCESS &&
      charge.stripe_product_id !== import.meta.env.REACT_APP_PRODUCT_RET_SER_20FT
  );

  if (filteredCharges.length === 0) return [];

  // Process each filtered charge
  return filteredCharges
    .map((charge) => {
      const [firstPrice] = charge.product_prices;
      if (!firstPrice) return null;
      return {
        id: firstPrice.id,
        name: charge.name,
        type: charge.type,
        quantity: firstPrice.tier_start_unit || 1,
        price_id: firstPrice.stripe_product_id,
        cost: parseFloat(firstPrice.unit_amount), // Convert to currency format
        total:
          parseFloat(firstPrice.unit_amount) *
          (firstPrice.tier_start_unit || 1),
        product_prices: charge.product_prices,
      };
    })
    .filter((item) => item !== null);
};

export function getWeekCountBetweenDates(startDate, endDate) {
  const start = moment(startDate).startOf("week");
  const end = moment(endDate).startOf("week");
  const weekCount = end.diff(start, "weeks") + 1; // Adding 1 to include the first week
  return weekCount;
}

// Example usage
